export default __webpack_public_path__ + "img/link-wx-ma.719d7506.jpg";